// See TEMPLATE_FORMAT.md for the template authoring syntax reference.

import type { Template } from "@/types/template";
import FGA_SOURCE from "@/store/seeds/fga.md?raw";
import BERG_SOURCE from "@/store/seeds/berg.md?raw";
import MINIBESTEST_SOURCE from "@/store/seeds/minibestest.md?raw";
import MASTER_SOURCE from "@/store/seeds/master.md?raw";
import TUG_SOURCE from "@/store/seeds/tug.md?raw";
import DGI_SOURCE from "@/store/seeds/dgi.md?raw";
import ABC_SOURCE from "@/store/seeds/abc.md?raw";
import DHI_SOURCE from "@/store/seeds/dhi.md?raw";
import LEFS_SOURCE from "@/store/seeds/lefs.md?raw";
import DASH_SOURCE from "@/store/seeds/dash.md?raw";
import SOAP_SOURCE from "@/store/seeds/soap.md?raw";

function seedTemplate(id: string, source: string): Template {
  return { createdAt: 1, id, source, updatedAt: 1 };
}

function hashSource(source: string): number {
  let h = 0;
  for (let i = 0; i < source.length; i++) {
    h = Math.trunc(Math.imul(31, h) + (source.codePointAt(i) ?? 0));
  }
  return h;
}

export function getSeedTemplates(): Template[] {
  return [
    seedTemplate("seed-fga", FGA_SOURCE),
    seedTemplate("seed-berg", BERG_SOURCE),
    seedTemplate("seed-minibestest", MINIBESTEST_SOURCE),
    seedTemplate("seed-tug", TUG_SOURCE),
    seedTemplate("seed-dgi", DGI_SOURCE),
    seedTemplate("seed-abc", ABC_SOURCE),
    seedTemplate("seed-dhi", DHI_SOURCE),
    seedTemplate("seed-lefs", LEFS_SOURCE),
    seedTemplate("seed-dash", DASH_SOURCE),
    seedTemplate("seed-soap", SOAP_SOURCE),
    seedTemplate("seed-master", MASTER_SOURCE),
  ];
}

export function isSeedId(id: string): boolean {
  return id.startsWith("seed-");
}

export function getSeedHashes(): Record<string, number> {
  return Object.fromEntries(getSeedTemplates().map((s) => [s.id, hashSource(s.source)]));
}
